import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import ConstantsUtil from '../../context/constantsUtil'
import HandleErrorService from '../../app/service/handleErrorService'
import GeneralServices from '../../app/service/generalServices'
import TableFilters from '../tableFilters'
import TooltipButton from '../tooltipButton'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { ProgressSpinner } from 'primereact/progressspinner'
import { classNames } from 'primereact/utils'
import AuthService from '../../app/service/authService'
import DialogFooter from '../dialogFooter'
import { InputNumber } from 'primereact/inputnumber'
import CustomCalendar from '../calendar/customCalendar'
import * as popUp from '../toastr'
import ConfirmationDialog from '../confirmationDialog'
import EstoqueCMVService from '../../app/service/estoque/estoqueCMVService'
import ReceitaServicoService from '../../app/service/receitaServicoService'
import CentralService from '../../app/service/central/centralService'

class LancamentoDataValorTable extends React.Component {

    constructor(){
        super()
        this.tableFilters = new TableFilters()
        this.dt = React.createRef()
        this.estoqueCMVService = new EstoqueCMVService()
        this.receitaServicoService = new ReceitaServicoService()
        this.centralService = new CentralService;

    }

    state = {

        list: [],
        loading: false,

        lancamentoToDelete: '',
        displayConfirmDeleteDialog: false,

    }

    
    componentDidMount(){
        this.search()
    }

    search = () => {
        this.setState({loading: true})
        this.handleSearch()
        .then(response => {
            // let list =  this.trataResponse(response.data)
            let list =  response.data
            this.setState({list})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    handleSearch = () => {

        switch(this.props.modo){
            case ConstantsUtil.modoValorDeEstoque:
                return this.estoqueCMVService.search(this.props.initialDate, this.props.finalDate)
                
            case ConstantsUtil.modoReceitaDeVendas:
                return this.handleReceitaServicoSearch()
        }

    }

    handleReceitaServicoSearch = () => {
        // console.log("this.props: ", this.props)
        if(this.props.unificar){
            return this.centralService.searchReceitaServicoUnificada(this.props.initialDate, this.props.finalDate, this.props.empresasList)
        }
        else{
            return this.receitaServicoService.search(this.props.initialDate, this.props.finalDate)
        }
    }

    callDelete = lancamentoToDelete => {
        this.setState({
            lancamentoToDelete,
            displayConfirmDeleteDialog: true,
        })
    }

    hideConfirmDeleteDialog = () => {
        this.setState({
            lancamentoToDelete: null,
            displayConfirmDeleteDialog: false,
        })        
    }

    confirmDeleteProvisao = () => {
        AuthService.startBlockUi()
        this.handleDelete()
        .then(response => {
            popUp.successPopUp("Lançamento deletado com sucesso!")
            this.search()
            this.hideConfirmDeleteDialog()
        })
        .catch(error => HandleErrorService.handleError(error))
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    handleDelete = () => {

        switch(this.props.modo){
            case ConstantsUtil.modoValorDeEstoque:
                return this.estoqueCMVService.deleteById(this.state.lancamentoToDelete.id)
                
            case ConstantsUtil.modoReceitaDeVendas:
                return this.receitaServicoService.deleteById(this.state.lancamentoToDelete.id)
        }

    }

    render(){

        const dataFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataLancamento,
            this.state.list,
            "selectedDataLancamento",
            (name, value) => this.setState({[name]: value}),
            'dataLancamento',
            '100%',
            "Data"
        ) 

        const valorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValor,
            this.state.list,
            "selectedValor",
            (name, value) => this.setState({[name]: value}),
            'valor',
            '100%',
            "Data"
        ) 

        const empresaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedEmpresa,
            this.state.list,
            "selectedEmpresa",
            (name, value) => this.setState({[name]: value}),
            'empresa',
            '100%',
            "Empresa"
        ) 

        const actionBody = (lancamento) => {
            return (
                <div className='centraliza-conteudo-div'>
                    <TooltipButton
                        tooltip="Editar"
                        icon="pi pi-pencil"
                        onClick={() => this.props.viewDialog(lancamento)}
                        // style={ {maxHeight: '30px', maxWidth: '30px'} }
                    />
                    <TooltipButton
                        tooltip='Excluir'
                        className={ "p-button-rounded p-button-danger p-mr-2 right-button" }
                        icon="pi pi-trash"
                        onClick={() => this.callDelete(lancamento)}
                    />
                </div>
            );
        }

        const renderConfirmDeleteDialog = () => {
            return(
                <ConfirmationDialog
                    visible={this.state.displayConfirmDeleteDialog}
                    header={"Deletar Lançamento de Valor de Estoque"}
                    confimationMessage={"Deseja Confirmar?"}
                    width={"500px"}
                    confirm={this.confirmDeleteProvisao}
                    hide={this.hideConfirmDeleteDialog}
                />
            )
        }

        const renderAcoesColumn = () => {
            if(!this.props.unificar){
                return(
                    <Column
                        header="Ações" 
                        body={actionBody}
                    />
                )
            }
        }

        const renderEmpresaColumn = () => {
            if(this.props.unificar){
                return (
                    <Column
                        header="Empresa" 
                        field='empresa'
                        filter filterElement={empresaFilterElement}
                    />
                )
            }
        }

        const renderTable = () => {
            return (
                <DataTable
                    ref={this.dt}
                    value={this.state.list}
                    className="p-datatable-sm small-font"
                    rowHover
                    loading={this.state.loading}
                    scrollable
                    scrollHeight = {this.props.scrollHeight ? this.props.scrollHeight : "300px"}
                    showGridlines
                    rowClassName={this.rowClass}
                    // rowClassName={(rowData) => this.rowClassTransaction(rowData, this.props.product)}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.state.list.length)}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} lançamentos"
                >

                    <Column
                        header="Data"
                        field="dataLancamento"
                        // style ={ {width: '40px'} }
                        sortable
                        filter filterElement={dataFilterElement}
                    />                

                    <Column
                        header="Valor"
                        field="valor"
                        // style ={ {width: '40px'} }
                        sortable
                        filter filterElement={valorFilterElement}
                        body={rowData => GeneralServices.showFormattedIfNotNull(rowData.valor, true)}
                    />                

                    {renderAcoesColumn()}

                    {renderEmpresaColumn()}

                </DataTable>                
            )
        }

        return(

            <>

                {renderTable()}
                {renderConfirmDeleteDialog()}

            </>
        )
    }
    

}

export default LancamentoDataValorTable